export default (eventHub, { enabled }, store) => {
  if (enabled) {
    eventHub.$on('eventReport', ({ event, ecommerce, ...data }) => {
      if (event === 'purchase_paid') data.revenue = ecommerce.transaction.total
      if (ecommerce) data = { ...ecommerce, ...data }
      store.dispatch('logRocketTrack', { event, data })
    })
  }
}
